import { FormInputElement } from "@archetypes/form-element";
import { ChangeEvent, FC, memo, useCallback } from "react";
import "./textarea.scss";
import { LabelInfo } from "@components/label-info";
import { FormError } from "@components/form-error";

interface TextAreaProps extends FormInputElement {
  value?: string;
  rows?: number;
  cols?: number;
  maxLength?: number;
  onChange?: (text: string) => void;
  containerClass?: string;
  errorMessage?: string;
  placeholder?: string;
  width?: string;
  height?: string;
  labelClassName?: string;
  infoText?: string;
}

const TextareaComponent: FC<TextAreaProps> = ({
  id,
  label,
  containerClass,
  placeholder = "Type Something...",
  onChange,
  errorMessage,
  width,
  height,
  required,
  labelClassName,
  infoText,
  value,
  ...restProps
}) => {
  const handleTextChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value;
      onChange?.(value);
    },
    [onChange],
  );

  const textAreaStyle = {
    width: width, // Default to 100% width if not provided
    height: height, // Default to auto height if not provided
  };

  return (
    <div className={`text-wrapper ${containerClass ?? ""}`}>
      <LabelInfo
        label={label}
        labelClassName={labelClassName}
        required={required}
        infoText={infoText}
      />
      <textarea
        id={id}
        value={value ?? ""}
        onChange={handleTextChange}
        placeholder={placeholder}
        style={textAreaStyle}
        {...restProps}
      ></textarea>
      <FormError errorMessage={errorMessage} />
    </div>
  );
};

export const Textarea = memo(TextareaComponent);
